<template>
  <div class="section" id="myPagePerformer">
    <div class="columns">
      <div class="column is-8-desktop is-offset-2-desktop">
        <h1 class="subtitle">マイページ</h1>

        <div class="sectionwrap">
          <div class="columns is-align-items-center">
            <div class="column">
              <h2 class="heading">ユーザープロフィール</h2>
              <p class="text">
                ここで今のプロフイールを表示ここで今のプロフイールを表示<br />ここで今のプロフィールを表示
              </p>
            </div>
            <div class="column is-one-third-desktop">
              <router-link to="/profile">
                <b-button class="button is-primary is-fullwidth">
                  プロフィールを確認
                </b-button>
              </router-link>
            </div>
          </div>
        </div>

        <div class="sectionwrap">
          <div class="columns is-align-items-center">
            <div class="column">
              <h2 class="heading">配信予定設定</h2>
              <p class="is-size-7 has-text-danger text">
                ※設定時間をすぎると、自動で情報がリセットされ、パトロンには「次回配信未定」と表示されます
              </p>
            </div>
            <div class="column is-one-third-desktop">
              <router-link to="/live/schedule">
                <b-button class="button is-primary is-fullwidth">
                  配信予定管理
                </b-button>
              </router-link>
            </div>
          </div>
        </div>

        <div class="sectionwrap">
          <div class="columns is-align-items-center">
            <div class="column">
              <h2 class="heading">配信方法について</h2>
            </div>
            <div class="column is-one-third-desktop">
              <router-link to="/live/menu">
                <b-button class="button is-primary is-fullwidth">
                  pandoraの楽しみ方
                </b-button>
              </router-link>
            </div>
          </div>
        </div>

        <div class="sectionwrap">
          <div class="columns is-align-items-center">
            <div class="column">
              <h2 class="heading">今すぐ配信を始める</h2>
            </div>
            <div class="column is-one-third-desktop">
              <router-link to="/live/console">
                <b-button class="button is-primary is-fullwidth">
                  配信を始める
                </b-button>
              </router-link>
            </div>
          </div>
        </div>
        <div class="sectionwrap">
          <div class="columns is-align-items-center">
            <div class="column">
              <h2 class="heading">リスナーコメント</h2>
            </div>
            <div class="column is-one-third-desktop">
              <router-link to="/ranking/patron">
                <b-button class="button is-primary is-fullwidth">
                  リスナーコメントを見る
                </b-button>
              </router-link>
            </div>
          </div>
        </div>

        <div class="sectionwrap">
          <div class="columns is-align-items-center">
            <div class="column">
              <h2 class="heading">お気に入りのパフォーマー</h2>
            </div>
            <div class="column is-one-third-desktop">
              <router-link to="/mypage/liked-performer">
                <b-button class="button is-primary is-fullwidth">
                  お気に入りのパフォーマー確認
                </b-button>
              </router-link>
            </div>
          </div>
        </div>

        <div class="sectionwrap">
          <div class="columns is-align-items-center">
            <div class="column">
              <h2 class="heading">支払い情報管理</h2>
            </div>
            <div class="column is-one-third-desktop">
              <router-link to="/payment">
                <b-button class="button is-primary is-fullwidth">
                  支払い情報確認/編集
                </b-button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyPagePerformer'
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/mypage-performer.scss';
</style>
